import { ProductTags } from '@app/constants/product-tags.constants';
import { Price } from '@app/entities/price';

export type HotelSearched = Readonly<{
  CheckinDate: string;
  CheckoutDate: string;
  HotelName: string;
  HotelCode: string;
  HotelId: number;
  HotelProvider: HotelProvider;
  IsSearchedhotel: boolean;
  IsSearchedhotelOrder: number;
  ShortDescription: string;
  Destination: string;
  Category: number;
  Address: string;
  Images: string[];
  Latitude: number;
  PriceFrom: number;
  CurrencyCode: string;
  Longitude: number;
  Zone?: string;
  Ammenities: string;
  PreferenceOrder: number;
  BestVal: boolean;
  DeepLinkCode?: string;
  OptionId: number;
  RoomRates: HotelSearchedRoomRate[],
  Rooms: HotelSearchedRoom[],
  LowerRoom?: HotelLowerRoomRate,
  lowerPrice?: number,
  Score?: number,
  ProductReference?: string,
  ClassTag?: ProductTags,
  Tag?: string,
  RoomsByCode?: HotelRoomsByCode[],
  MaxTotalDiscountPercentage: number,
  FullAddress?: string,
  Thumbnail?: string,
  TotalNightsHotel?: number,
  Headline?: string,
  UnifiedHotelCode?: string,
  Distance?: number,
  ShowAmenitiesDisclaimer?: boolean,
  MicroStay?: boolean;
  DistanceFromAirport?: string;
  AirportCityCode?: string;
}>;

export type HotelRoomsByCode = Readonly<{
  Code: string;
  Description: string;
  Beds: HotelRoomBeds[];
  Amenities: HotelRoomAmenities[];
  Images: HotelRoomImages[];
  RoomsByRate: HotelSearchedRoom[];
}>;

export type HotelSearchedRoomRate = Readonly<{
  Price: Price;
  RefundableType: number;
  RefundableInfo: string;
  RoomIds: number[];
  RateId: string;
  Rooms?: HotelSearchedRoom[];
  TextFare?: string;
  MemberRateIndicator?: boolean;
  PackageRateIndicator?: boolean;
  PackHours?: number;
  CheckinTimes?: string[];
  Capacity?: number;
}>;

export type HotelLowerRoomRate = Readonly<{
  Price?: Price;
  RefundableType: number;
  RoomIds: number[];
  RateId: string;
  Rooms?: HotelSearchedRoom[];
  TextFare?: string;
}>;

export type HotelSearchedRoom = Readonly<{
  RoomId: number;
  RoomCode: string;
  Description: string;
  Adults: number;
  Children: number;
  BoardCode: string;
  BoardDescription: string;
  BoardTypeCode?: string;
  Smoking?: string;
  PetsAllowed?: string;
  SquareMeters?: string;
  SquareFeet?: string;
  MaxAdults?: string;
  MaxChildren?: string;
  ChildMinAge?: string;
  InfantMinAge?: string;
  AdultMinAge?: string;
  Beds?: HotelRoomBeds[];
  Amenities?: HotelRoomAmenities[];
  Images?: HotelRoomImages[];
  ParsedPromotionalText?: string[];
  PromotionalText?: string;
  RoomRateById?: HotelSearchedRoomRate;
  RefundableType?: number;
}>;

export type HotelRoomBeds = Readonly<{
  BedSize?: string;
  Description: string;
  Quantity: number;
}>;

export type HotelRoomAmenities = Readonly<{
  RoomAmenityId: number;
  CombinedUID: string;
  Locale: string;
  Description: string;
  HAC?: string;
  Highlight?: boolean;
}>;

export type HotelRoomImages = Readonly<{
  VisualOrder: number;
  Caption?: string;
  HeroImage: boolean;
  Category: string;
  Url: string;
}>;

export enum HotelProvider {
  Apitude = 'apitude',
  ExpediaRapid = 'ExpediaRapid',
  HotelDoV3 = 'HotelDoV3',
  MarriottBonvoy = 'MARRIOTT'
}
